import angular from 'angular';
import { get } from 'lodash';
import './modals/totems';
import '../services/totem';
import '../services/errors';
import '../services/place';
import '../app.constants';

const module = angular.module('whyline.controllers.totems', [
  'whyline.modals.totems',
  'whyline.services.totem',
  'whyline.services.place',
  'whyline.services.errors',
  'whyline.constants',
]);

const TotemsController = ($scope, $state, $uibModal, $translate, $timeout, $location, TotemService, PlaceService, NotificationService, ErrorService, dialog, currentOrganization, URL_NEW_KIOSK) => {
  /*@ngInject*/
  const merchantMaxTotems = 1; // TODO: change when plan scope gets implemented

  $scope.title = 'totems';
  $scope.quantityOfItems = 8;
  $scope.organizationId = $state.params.organizationId;
  $scope.placeId = $state.params.placeId;

  $scope.getTotemUrl = totem => {
    $scope.viewEasyTotem = get($scope.place, 'configuration.viewEasyTotem', false);
    const route = `totem${$scope.viewEasyTotem ? '-new' : ''}-tv.welcome`;
    const params = { placeId: totem.placeId, organizationId: $scope.organizationId, totemId: totem._id };
    return $state.href(route, params);
  };

  $scope.plan = {};
  $scope.plan.maxTotems = get(currentOrganization, 'configuration.plan.maxTotems', merchantMaxTotems);

  $scope.canCreateTotem = () => {
    const maxTotems = parseInt($scope.plan.maxTotems, 10);
    return Object.keys($scope.totems).length < maxTotems || maxTotems === -1;
  };

  $scope.remove = (totemId, name) => {
    let n = name || '';
    let text = $translate.instant('totem_{name}_remove_sure').replace('{name}', n);
    dialog.confirm(text)
      .then(() => {
        TotemService.Remove(totemId)
          .then(() => {
            let n = name || '';
            let text = $translate.instant('totem_{name}_remove_succ').replace('{name}', n);
            NotificationService.Success(text);
          })
          .catch(ErrorService.handler);
      });
  };

  $scope.switch = TotemService.Switch;

  $scope.refresh = totemId => TotemService.Refresh(totemId);

  // Modal
  $scope.open = totemId => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/totems-modal.html',
      size: 'lg',
      controller: 'TotemModalController',
      resolve: {
        totemId: () => totemId
      }
    });
  };

  $scope.redirectToTotem = (totemId, totemUrl, withVirtualKeyboard) => {
    TotemService.GetTotemBAHash(totemId)
      .then(hash => {
        const kioskUrl = totemUrl;
        const fullUrl = withVirtualKeyboard ? `${kioskUrl}?virtualine=${hash}&organizationId=${$scope.organizationId}&placeId=${$scope.place._id}&totemId=${totemId}&showVirtualKeyboard=${withVirtualKeyboard}` : `${kioskUrl}?virtualine=${hash}&organizationId=${$scope.organizationId}&placeId=${$scope.place._id}&totemId=${totemId}`
        window.open(fullUrl, '_blank');
      })
      .catch(ErrorService.handler);
  };

  $scope.$on('placeSaved', (evt, data) => {
    if (data._id === $scope.placeId) {
      getPlace();
      getTotems();
    }
  });

  $scope.$on('org-updated', (evt, data) => {
    if (data._id === $scope.organizationId) {
      getPlace();
      getTotems();
    }
  });

  const getTotems = () => {
    $scope.totems = [];

    TotemService.GetAllAsPromiseFromServer()
      .then(totems => {
        $scope.totems = totems;
      });
  };

  const getPlace = () => {
    PlaceService.GetCurrentAsPromise()
    .then(place => {
      $timeout(() => {
        $scope.place = place;
        $scope.currentTotemVersion = get(place,'configuration.currentTotemVersion','v2');
      });
    });
  };

  const init = () => {
    getPlace();
    getTotems();
  };

  init();
};

module.exports = module.controller('TotemsController', TotemsController);
